export const engagementWebhookTemplatesTerritories = "/engagement/webhook_templates/territories";
